import { Component, Input, OnInit } from '@angular/core';
import { CmUiBugType } from '../../models/cm-ui-bug-type.enum';

@Component({
    selector: 'cm-ui-bug',
    templateUrl: './ui-bug.component.html',
    styleUrls: ['./ui-bug.component.scss'],
    standalone: false
})
export class CmUIBugComponent implements OnInit {
	@Input() type: CmUiBugType = CmUiBugType.INFO;
	@Input() bugTitle: string;
	@Input() content: string;

	constructor() {}

	ngOnInit() {}
}
